import { render, staticRenderFns } from "./eComplaintTaskDetail.vue?vue&type=template&id=26639be5"
import script from "./eComplaintTaskDetail.vue?vue&type=script&lang=js"
export * from "./eComplaintTaskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports